import { useSelector } from 'react-redux';
import { toast } from 'sonner';

const useAIAgentDefineValidator = () => {
  const agentType = useSelector(state => state.agent.aiAgent?.aiAgentData?.aiAgentType);
  const agentTitle = useSelector(state => state.agent.aiAgent?.title);
  const agentDescription = useSelector(state => state.agent.aiAgent?.description);
  const gaPropertyId = useSelector(state => state.agent.aiAgent?.aiAgentData?.gaPropertyId);

  const validateBasicFields = () => {
    const hasValidTitle = agentTitle && agentTitle.trim().length > 0;
    const hasValidDescription = agentDescription && agentDescription.trim().length > 0;

    if (!hasValidTitle) {
      toast.warning('Enter a name for this agent');
      return true;
    }

    if (!hasValidDescription) {
      toast.warning('Add a description for this agent');
      return true;
    }

    return false;
  };

  const isAIAgentDefineNextButtonDisabled = () => {
    // Check basic fields first
    const hasBasicFieldErrors = validateBasicFields();
    if (hasBasicFieldErrors) {
      return true;
    }

    // If agent type is DEA, also check for GA property ID
    if (agentType === 'DEA') {
      const hasValidGaPropertyId = gaPropertyId && gaPropertyId.trim().length > 0;

      if (!hasValidGaPropertyId) {
        toast.warning('Enter a valid Google Analytics property ID');
        return true;
      }
    }

    return false;
  };

  return { isAIAgentDefineNextButtonDisabled };
};

export default useAIAgentDefineValidator;
